export default {
  brandName: "بورا",
  logoAlt: "لوگوی {{brandName}}",
  tagline:
    "خلق تجربه‌های دیجیتال که فناوری و خلاقیت را به هم متصل می‌کند. موفقیت شما، انرژی‌بخش ماست.",
  quickLinksTitle: "لینک‌های سریع",
  quickLinks: {
    home: "خانه",
    javad: "درباره جواد",
    faranack: "درباره فرانک",
    contact: "تماس",
  },
  connectTitle: "با ما در ارتباط باشید",
  socialLabels: {
    email: "ایمیل",
    website: "وب‌سایت",
    github: "گیت‌هاب",
    telegram: "تلگرام",
  },
  readyPrompt: "آماده شروع پروژه‌تان هستید؟",
  copyright: "© {{year}} بورا | تمامی حقوق محفوظ است.",
  builtWithPrefix: "ساخته‌شده با",
  builtWithSuffix: "و فناوری",
  scrollToTop: "بازگشت به بالا",
};
